import { useRegistryStore } from '@/stores/registry.store'
import { useWebSiteStore } from '@/stores/web-site.store'

export const useSubjectService = () => {
  const registryStore = useRegistryStore()
  const webSiteStore = useWebSiteStore()

  const setSubjectType = (newData, currentData, subject_type_ref, subject_sub_type_ref = null) => {
    newData = newData || {}
    newData.subject_type_ref = subject_type_ref
    newData.subject_sub_type_ref = subject_sub_type_ref

    const subjectType = registryStore.subjectTypes.find(i => i.id === (newData.subject_sub_type_ref || newData.subject_type_ref))
    if (subjectType) {
      if (currentData.rows_count === 0) {
        newData.includes_vat = subjectType.has_prices_with_vat
      }

      if (!subjectType.has_identity_data) {
        newData.birth_country = null
        newData.birth_city = null
        newData.birth_place = null
        newData.birth_date = null
        newData.job_type_ref = null
        newData.identity_document_number = null
        newData.identity_document_type_ref = null
        newData.identity_document_authority_ref = null
        newData.identity_document_date = null
        newData.identity_document_city = null
        newData.identity_document_state = null
      }

      if (!subjectType.has_vat_number) {
        newData.vat_country = null
        newData.vat_number = null
      }
      if (!subjectType.has_tax_code) {
        newData.tax_code = null
      }
    }
  }

  const isVatCountryIta = (vatCountryId) => {
    const vatCountryCode = webSiteStore.countries.find(x => x.id === vatCountryId)?.iso3_code
    return vatCountryCode === 'ITA'
  }

  const isVatNumberMandatory = (subjectSubTypeId, vatCountryId) => {
    const vatCountryCode = webSiteStore.countries.find(x => x.id === vatCountryId)?.iso3_code
    const subjectSubType = registryStore.subjectTypes.find(x => x.id === subjectSubTypeId)
    return subjectSubType?.has_vat_number && vatCountryCode === 'ITA'
  }

  const isNameExtMandatory = (subjectTypeId) => {
    const subjectType = registryStore.subjectTypes.find(x => x.id === subjectTypeId)
    const code = subjectType?.parent_id ? registryStore.subjectTypes.find(x => x.id === subjectType.parent_id)?.code : subjectType?.code
    return code === 'P'
  }

  const isTaxCodeMandatory = (subjectTypeId, vatCountryId) => {
    const vatCountryCode = webSiteStore.countries.find(x => x.id === vatCountryId)?.iso3_code
    const subjectType = registryStore.subjectTypes.find(x => x.id === subjectTypeId)
    return subjectType?.has_tax_code || vatCountryCode !== 'ITA'
  }

  return {
    setSubjectType,
    isVatCountryIta,
    isVatNumberMandatory,
    isNameExtMandatory,
    isTaxCodeMandatory
  }
}
